import UnderConstruction from "../common/UnderConstruction";

export default function InventorySuppliers() {
  return <UnderConstruction title="Suppliers" />;
}
